import type { Locale } from "../i18n";

const SITE_NAME = "GSplat Share";

const ogLocales: Record<Locale, string> = {
	en: "en_US",
	ja: "ja_JP",
};

type SocialMetaArgs = {
	title: string;
	description: string;
	url: string;
	image: string;
	locale: Locale;
	type?: "website";
};

export function socialMeta({ title, description, url, image, locale, type = "website" }: SocialMetaArgs) {
	const alternateLocale = locale === "ja" ? "en" : "ja";

	return [
		{ property: "og:type", content: type },
		{ property: "og:site_name", content: SITE_NAME },
		{ property: "og:title", content: title },
		{ property: "og:description", content: description },
		{ property: "og:url", content: url },
		{ property: "og:image", content: image },
		{ property: "og:image:secure_url", content: image },
		{ property: "og:image:type", content: "image/jpeg" },
		{ property: "og:image:width", content: "1200" },
		{ property: "og:image:height", content: "630" },
		{ property: "og:image:alt", content: title },
		{ property: "og:locale", content: ogLocales[locale] },
		{ property: "og:locale:alternate", content: ogLocales[alternateLocale] },
		{ name: "twitter:card", content: "summary_large_image" },
		{ name: "twitter:title", content: title },
		{ name: "twitter:description", content: description },
		{ name: "twitter:image", content: image },
	];
}
